import { Input, InputGroup, InputLeftElement, FormLabel, InputProps } from '@chakra-ui/react';
import { ChangeEvent, MutableRefObject } from 'react';
import { faSearch } from '@fortawesome/pro-regular-svg-icons';
import { Icon } from '~/ui-components';

export type SearchInputProps = InputProps & {
   name: string;
   value: string;
   placeholder?: string;
   onChange: (e: ChangeEvent<HTMLInputElement>) => any;
   refFocus?: MutableRefObject<null> | null;
};

/**
 * SearchInput
 *  Stateless component which adds markup necessary to improve accessibility
 */
export function SearchInput({
   name,
   value,
   onChange,
   placeholder,
   refFocus,
   ...inputProps
}: SearchInputProps) {
   return (
      <>
         <FormLabel htmlFor={name} visibility="hidden" height={0} m={0}>
            {placeholder}
         </FormLabel>
         <InputGroup bgColor="white">
            <InputLeftElement pointerEvents="none" h="full" ml={1}>
               <Icon type={faSearch} color="blueGray.600" />
            </InputLeftElement>
            <Input
               ref={refFocus}
               id={name}
               value={value}
               onChange={onChange}
               placeholder={placeholder}
               {...inputProps}
            />
         </InputGroup>
      </>
   );
}
